require("whatwg-fetch");

// const { getCLS, getFID, getLCP } = require("web-vitals");
const {
  trackCustomException,
  // trackCustomEvent,
} = require("./src/utilities/analytics");

// const sendWebVitalsToGoogleAnalytics = ({ name, delta, id }) => {
//   trackCustomEvent({
//     category: "Web Vitals",
//     action: name,
//     // The `id` value will be unique to the current page load. When sending
//     // multiple values from the same page (e.g. for CLS), Google Analytics can
//     // compute a total by grouping on this ID (note: requires `eventLabel` to
//     // be a dimension in your report).
//     label: id,
//     // Google Analytics metrics must be integers, so the value is rounded.
//     // For CLS the value is first multiplied by 1000 for greater precision
//     // (note: increase the multiplier for greater precision if needed).
//     value: Math.round(name === "CLS" ? delta * 1000 : delta),
//     // Use a non-interaction event to avoid affecting bounce rate.
//     nonInteraction: true,
//     // Use `sendBeacon()` if the browser supports it.
//     transport: "beacon",
//   });
// };

const logExceptionsToGA = () => {
  if (typeof window.onerror === "object") {
    // https://developer.mozilla.org/en-US/docs/Web/API/GlobalEventHandlers/onerror#notes
    window.onerror = function (msg, url, lineNo, columnNo, error) {
      const description = [
        "Message: " + msg,
        "URL: " + url,
        "Line: " + lineNo,
        "Column: " + columnNo,
        "Error object: " + JSON.stringify(error),
      ].join(" - ");

      trackCustomException(description);
    };

    return false;
  }
};

exports.onClientEntry = () => {
  // getCLS(sendWebVitalsToGoogleAnalytics);
  // getFID(sendWebVitalsToGoogleAnalytics);
  // getLCP(sendWebVitalsToGoogleAnalytics);
  logExceptionsToGA();
};
